import { render } from "./FavouriteSupplierView.vue?vue&type=template&id=b3b48d32"
import script from "./FavouriteSupplierView.vue?vue&type=script&lang=js"
export * from "./FavouriteSupplierView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__